/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable react/jsx-props-no-spreading */
import React, {
  createContext, useContext, useEffect, useState,
} from 'react';
import { ChangeHistoryContextProps } from './ChangeHistoryContext.types';
import { ChangeHistoryProviderProps } from './ChangeHistoryProvider.types';

const ChangeHistoryContext = createContext<ChangeHistoryContextProps>(undefined!);
export function useChangeHistory() {
  return useContext(ChangeHistoryContext);
}

// eslint-disable-next-line react/prop-types
export function ChangeHistoryProviderBase({ children }: ChangeHistoryProviderProps) {
  const [changeHistoryDrawerOpen, setChangeHistoryDrawerOpen] = useState<boolean>(false);
  const [changeHistoryReferenceId, assignChangeHistoryReferenceId] = useState<string | undefined>();
  const [referenceId, setReferenceId] = useState<string | undefined>();
  const [reset, setReset] = useState<boolean>(true);

  function setChangeHistoryReferenceId(newReferenceId: string) {
    setReferenceId(newReferenceId);
  }

  function resetChangeHistoryReferenceId() {
    assignChangeHistoryReferenceId(undefined);
    setReset(true);
  }

  useEffect(() => {
    if (reset) {
      assignChangeHistoryReferenceId(referenceId);
      setReferenceId(undefined);
      setReset(false);
    }
  }, [reset]);

  return (
    <ChangeHistoryContext.Provider
      value={{
        changeHistoryReferenceId,
        changeHistoryDrawerOpen,
        setChangeHistoryDrawerOpen,
        setChangeHistoryReferenceId,
        resetChangeHistoryReferenceId,
      }}
    >
      {children}
    </ChangeHistoryContext.Provider>
  );
}

export function ChangeHistoryProvider({ children }: ChangeHistoryProviderProps) {
  return (
    <ChangeHistoryProviderBase>
      {children}
    </ChangeHistoryProviderBase>
  );
}
